// extracted by mini-css-extract-plugin
export default {"title":"Events_title__VhBJr"};